import { Input } from 'legacy/libs/react-form-tools'
import createReactClass from 'create-react-class'
import { GetText } from 'lib/gettext'

import s from './styles/gis-region.module.scss'

export default createReactClass({
  displayName: 'AdditionalInfo',

  render() {
    return (
      <div>
        <label htmlFor="inputAdditionalInfo">
          <GetText>
            Please provide us with a brief description of your desired map. Some
            examples include:
          </GetText>
          <br />

          <ul className="mb-4 list-disc pl-6 text-sm">
            <li>
              <GetText>“I want Spain with these 5 cities...”</GetText>
            </li>

            <li>
              <GetText>
                “I want China`s Hunan province with part of this adjacent
                province...(link to image)”
              </GetText>
            </li>

            <li>
              <GetText>“I want this map from this website (link)”</GetText>
            </li>

            <li>
              <GetText>“I want the map on page 3 of (citation)”</GetText>
            </li>
          </ul>
        </label>

        <Input
          className={s.input}
          id="inputAdditionalInfo"
          type="textarea"
          {...this.props}
        />
      </div>
    )
  },
})
